<template>
	<div class="all-notifications"><sym-icon name="replan"></sym-icon> {{ env.msg('butt.remindAllLater') }}</div>
</template>

<script setup lang="ts">
import SymIcon from "@fd/helpers/SymIcon.vue";
import {injectEnv} from "@fd/Environment.ts";

const env = injectEnv();
</script>

<style>
.all-notifications {
	padding: 0 16px;
	height: 28px;
	line-height: 28px;
	border-radius: 16px;
	font-size: 12px;
	max-width: none;
	background-color: var(--button-ternary-bg);
	color: var(--button-ternary-fg);
	align-self: flex-start;
	cursor: pointer;
	box-shadow: var(--panel-shadow);
	pointer-events: auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	column-gap: 4px;
}
.all-notifications:hover {
	background-color: var(--button-ternary-bg-hover);
	color: var(--button-ternary-fg-hover);
}
.all-notifications > .fi {
	font-size: 14px;
}
</style>